import { OFFER_KIND } from '../../../../../../views/menu/offers/constants';

export default {
  title: 'Detalii ofertă',
  types: {
    [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Setați cheltuiala eligibilă și % reducere',
      qualifying_criteria: {
        title: 'Sumă minimă de cheltuială',
        description: 'Setați suma eligibilă de cheltuială',
      },
      details: {
        title: '% reducere',
        description: 'Setați reducerea pe care clienții o vor primi din comandă',
      },
    },
    [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: {
      title: 'Setați cheltuiala pe produse eligibile și % reducere',
      qualifying_criteria: {
        title: 'Produse cu reducere',
        description: 'Selectați produsele pentru care oferiți o reducere.',
      },
      details: {
        title: '% reducere',
        description: 'Setați reducerea pe care clienții o vor primi din comandă',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: {
      title: 'Setați produsele eligibile și reducerea de {{currency}}',
      qualifying_criteria: {
        title: 'Produse cu reducere',
        description: 'Selectați produsele pentru care oferiți o reducere.',
      },
      details: {
        title: 'Reducere de {{currency}}',
        description: 'Setați reducerea pe care clienții o vor primi din comandă',
      },
    },
    [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: {
      title: 'Setați cheltuiala eligibilă și reducerea de {{currency}}',
      qualifying_criteria: {
        title: 'Sumă minimă de cheltuială',
        description: 'Setați suma eligibilă de cheltuială',
      },
      details: {
        title: 'Reducere de {{currency}}',
        description: 'Setați reducerea pe care clienții o vor primi din comandă',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: {
      title: 'Setați cheltuiala eligibilă și produsele gratuite',
      qualifying_criteria: {
        title: 'Sumă minimă de cheltuială',
        description: 'Setați suma pe care clientul trebuie să o cheltuiască pentru a obține produsul gratuit.',
      },
      details: {
        title: 'Produse gratuite:',
        description: 'Selectați produsul (sau produsele) gratuit din care clientul poate alege unul.',
      },
    },
    [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: {
      title: 'Alegeți cerințele ofertei',
      qualifying_criteria: {
        title: 'Produse eligibile',
        description: 'Selectați produsele pe care clientul trebuie să le comande pentru a obține produsul gratuit.',
      },
      details: {
        title: 'Produse gratuite:',
        description: 'Selectați produsul (sau produsele) gratuit din care clientul poate alege unul.',
      },
    },
    [OFFER_KIND.BOGO]: {
      title: 'Alegeți cerințele ofertei',
      qualifying_criteria: {
        title: 'Produse eligibile',
        description: 'Selectați categoria din care clientul trebuie să aleagă pentru a obține un produs gratuit.',
      },
      details: {
        title: 'Produs gratuit',
        description:
          'Clienții pot selecta al doilea produs din produsele eligibile selectate. Clientul va primi gratuit cel mai ieftin dintre cele două produse.',
      },
    },
  },
};
